import React from "react";

function IconMail({width}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="18"
      viewBox="0 0 5.827 4.763"
    >
      <g fill="none" stroke="#313131">
        <path
          d="M-182.79 18.96h4.234a.53.53 0 01.53.53v3.175a.53.53 0 01-.53.529h-4.233a.53.53 0 01-.53-.53V19.49a.53.53 0 01.53-.53z"
          transform="translate(183.586 -18.696)"
        ></path>
        <path
          strokeWidth="0.265"
          d="M-178.028 19.487l-2.646 1.852-2.645-1.852"
          transform="translate(183.586 -18.696)"
        ></path>
      </g>
    </svg>
  );
}

export default IconMail;
